import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import "./PreviewImage.css";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import ValidateIcon from "@material-ui/icons/Check";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";

const styles = {
	icon: {
		color: "#D50000",
	},
	appBar: {
		position: "relative",
		marginBottom: "10px",
	},
	flex: {
		flex: 1,
	},
};

class PreviewImage extends Component {
	render() {
		const { classes } = this.props;

		return (
			<Dialog
				fullScreen
				onClose={this.props.close.bind(this)}
				aria-labelledby="simple-dialog-title"
				open={true}
			>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton
							color="inherit"
							onClick={this.props.close}
							aria-label="Close"
						>
							<CloseIcon />
						</IconButton>
						<Typography variant="h6" color="inherit" className={classes.flex}>
							Aperçu
						</Typography>
					</Toolbar>
				</AppBar>
				<DialogContent className="container">
					<img src={this.props.image} alt="Aperçu" />
				</DialogContent>
				{!this.props.disabled ? (
					<DialogActions>
						<div className="col-lg-6 col-md-6 col-sm-6 col-6">
							<IconButton onClick={this.props.delete}>
								<DeleteIcon className={classes.icon} />
							</IconButton>
						</div>
						<div className="col-lg-6 col-md-6 col-sm-6 col-6 right without-side-padding">
							<IconButton onClick={this.props.close}>
								<ValidateIcon />
							</IconButton>
						</div>
					</DialogActions>
				) : null}
			</Dialog>
		);
	}
}

export default withStyles(styles)(PreviewImage);
